(function () {
  if (window.__mcVarGallery) return;
  window.__mcVarGallery = true;
  if (!/\/products\//.test(location.pathname)) return;

  function prefixOf(src) {
    var fn = (src || '').split('/').pop().split('?')[0];
    var m = fn.match(/^(\d{3,})/);
    return m ? m[1] : null;
  }
  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  var slider,
    flkInst,
    product,
    mediaColor = {},
    colorPrefix = {},
    ready = false;
  var mode = 'prefix',
    groupColors = {};

  function getFlk() {
    try {
      return window.Flickityt4s && window.Flickityt4s.data ? window.Flickityt4s.data(slider) : null;
    } catch (e) {
      return null;
    }
  }
  function navEl() {
    try {
      return slider.flickityt4s && slider.flickityt4s.$carouselNav
        ? slider.flickityt4s.$carouselNav[0]
        : null;
    } catch (e) {
      return null;
    }
  }

  function currentVariant() {
    var idEl = document.querySelector(
      'form[action="/cart/add"] [name="id"], [data-product-featured] [name="id"]',
    );
    if (idEl && product)
      return (
        product.variants.filter(function (x) {
          return String(x.id) === String(idEl.value);
        })[0] || null
      );
    return null;
  }

  var colorIdx = -1;
  function detectColorIdx(p) {
    var opts = p.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '';
      if (/colou?r|finish|fabric|material|wood|shade|upholstery/i.test(name)) return i;
    }
    return opts.length ? opts.length - 1 : 1;
  }
  function colorOf(v) {
    if (!v) return null;
    if (colorIdx >= 0) return v['option' + (colorIdx + 1)];
    return v.option2;
  }
  function currentColor() {
    var v = currentVariant();
    var c = colorOf(v);
    if (c) return c;
    var sel = document.querySelector(
      '.t4s-swatch__option.is-t4s-style__color [data-swatch-item].is--selected, [data-swatch-option][class*="color" i] [data-swatch-item].is--selected',
    );
    return sel ? sel.getAttribute('data-value') : null;
  }

  function filterTo(color, featId) {
    if (!ready || !color) return;
    if (mode === 'prefix') {
      if (!colorPrefix[color]) return;
    } else if (!groupColors[color]) return;

    var slides = slider.querySelectorAll('[data-main-slide]');
    var anyShown = false,
      featIndexInVisible = 0,
      visIdx = 0;
    slides.forEach(function (s) {
      var c = mediaColor[s.getAttribute('data-media-id')];
      var show = c === color || (mode !== 'prefix' && c === '*');
      s.classList.toggle('is--media-hide', !show);
      if (show) {
        if (featId && String(s.getAttribute('data-media-id')) === String(featId))
          featIndexInVisible = visIdx;
        visIdx++;
        anyShown = true;
      }
    });
    if (!anyShown) {
      slides.forEach(function (s) {
        s.classList.remove('is--media-hide');
      });
      return;
    }

    var nav = navEl();
    if (nav && mode !== 'prefix') {
      [].forEach.call(nav.children, function (it, i) {
        var s = slides[i],
          c = s ? mediaColor[s.getAttribute('data-media-id')] : null;
        it.classList.toggle('mc-vg-hide', !(c === color || c === '*'));
      });
    } else if (nav) {
      [].forEach.call(nav.children, function (it) {
        var img = it.querySelector('img');
        var bg = img ? img.getAttribute('src') || img.getAttribute('data-src') : '';
        if (!bg) {
          var inner = it.querySelector('[style*="url("]');
          if (inner) {
            var mm = inner.getAttribute('style').match(/url\(([^)]+)\)/);
            bg = mm ? mm[1] : '';
          }
        }
        var ic = colorPrefixToColor(prefixOf(bg));
        it.classList.toggle('mc-vg-hide', ic !== color);
      });
    }

    flkInst = getFlk();
    if (flkInst && flkInst.reloadCells) {
      try {
        flkInst.reloadCells();
        flkInst.resize();

        if (
          flkInst.selectedElement &&
          flkInst.selectedElement.classList.contains('is--media-hide')
        ) {
          flkInst.selectedIndex = featIndexInVisible;
          if (flkInst.positionSlider) flkInst.positionSlider();
        }
      } catch (e) {}
    }
    if (mode !== 'prefix') capDots();
  }
  function apply() {
    var v = currentVariant();
    filterTo(currentColor(), v && v.featured_media && v.featured_media.id);
  }

  var prefColor = {};
  function colorPrefixToColor(pref) {
    return pref ? prefColor[pref] || null : null;
  }

  function build(p) {
    product = p;
    colorIdx = detectColorIdx(p);

    p.variants.forEach(function (v) {
      var color = colorOf(v);
      if (!color) return;
      if (!colorPrefix[color] && v.featured_media && v.featured_media.preview_image) {
        var pf = prefixOf(v.featured_media.preview_image.src);
        if (pf) {
          colorPrefix[color] = pf;
          prefColor[pf] = color;
        }
      }
    });

    p.media.forEach(function (m) {
      var pf = prefixOf(m.preview_image ? m.preview_image.src : m.src);
      if (pf && prefColor[pf]) mediaColor[m.id] = prefColor[pf];
    });
  }

  function cleanGrouping(mc, colours) {
    var size = {},
      shared = 0;
    Object.keys(mc).forEach(function (id) {
      var c = mc[id];
      if (c === '*') shared++;
      else size[c] = (size[c] || 0) + 1;
    });
    var cs = Object.keys(colours);
    if (cs.length < 2 || shared > 2) return false;
    var min = Infinity,
      max = 0;
    for (var i = 0; i < cs.length; i++) {
      var n = size[cs[i]] || 0;
      if (n < 3) return false;
      if (n < min) min = n;
      if (n > max) max = n;
    }
    return max <= 3 * min;
  }
  function buildFallback(p) {
    var opts = p.options || [],
      named = false;
    for (var i = 0; i < opts.length; i++) {
      var nm = typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name) || '';
      if (/colou?r|finish|fabric|material|wood|shade|upholstery/i.test(nm)) {
        named = true;
        break;
      }
    }
    if (!named) return false;

    var colours = {},
      names = {};
    p.variants.forEach(function (v) {
      var c = colorOf(v);
      if (c) {
        colours[c] = 1;
        names[String(c).toLowerCase()] = c;
      }
    });

    var anchor = {};
    p.variants.forEach(function (v) {
      var c = colorOf(v);
      if (c && v.featured_media && !(v.featured_media.id in anchor))
        anchor[v.featured_media.id] = c;
    });
    var seen = {},
      cur = '*',
      byPos = {};
    p.media.forEach(function (m) {
      if (anchor[m.id] && !seen[anchor[m.id]]) {
        cur = anchor[m.id];
        seen[cur] = 1;
      }
      byPos[m.id] = cur;
    });

    var byAlt = {};
    p.media.forEach(function (m) {
      var tail = String(m.alt || '')
        .split(' - ')
        .pop()
        .trim()
        .toLowerCase();
      byAlt[m.id] = names[tail] || '*';
    });

    var named2 = 0;
    for (var q = 0; q < p.media.length; q++) if (byAlt[p.media[q].id] !== '*') named2++;
    if (named2 < 0.9 * p.media.length) return false;
    for (var k = 0; k < p.media.length; k++) {
      var id = p.media[k].id;
      if (byAlt[id] !== '*' && byAlt[id] !== byPos[id]) return false;
    }

    p.media.forEach(function (m) {
      if (byAlt[m.id] === '*' && byPos[m.id] !== '*') byPos[m.id] = '~';
    });
    if (!cleanGrouping(byPos, colours)) return false;
    mediaColor = byPos;
    groupColors = seen;
    mode = 'position';
    return true;
  }

  function capDots() {
    try {
      var wrap = slider.closest('.t4s-product__media-wrapper') || slider.parentNode;
      var count = function () {
        return slider.querySelectorAll('[data-main-slide]:not(.is--media-hide)').length;
      };
      var many = count() > 15;
      wrap.classList.toggle('mc-vg-many', many);
      var ctr = wrap.querySelector('.mc-vg-count');
      if (!many) {
        if (ctr) ctr.parentNode.removeChild(ctr);
        return;
      }
      if (!ctr) {
        ctr = document.createElement('div');
        ctr.className = 'mc-vg-count';
        slider.parentNode.insertBefore(ctr, slider.nextSibling);
      }
      var upd = function () {
        var f = getFlk();
        var c = wrap.querySelector('.mc-vg-count');
        if (c) c.textContent = ((f && f.selectedIndex) || 0) + 1 + ' / ' + count();
      };
      upd();
      var f0 = getFlk();
      if (f0 && f0.on && !slider.__mcVgCount) {
        slider.__mcVgCount = true;
        f0.on('select', upd);
      }
    } catch (e) {}
  }

  function init() {
    slider = document.querySelector(
      '.t4s-product__media-wrapper .flickityt4s[data-flickityt4s-js]',
    );
    if (!slider) return;
    var slideCount = slider.querySelectorAll('[data-main-slide]').length;
    if (slideCount <= 8) return;
    var h = handle();
    if (!h) return;

    fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        build(p);

        if (Object.keys(colorPrefix).length < 2) {
          mediaColor = {};
          colorPrefix = {};
          prefColor = {};
          if (!buildFallback(p)) return;
        }

        function go() {
          flkInst = getFlk();
          if (!flkInst || !flkInst.reloadCells) {
            setTimeout(go, 150);
            return;
          }
          ready = true;
          apply();
        }
        go();

        var idEl = document.querySelector(
          'form[action="/cart/add"] [name="id"], [data-product-featured] [name="id"]',
        );
        if (idEl) {
          var last = idEl.value;
          var reapply = function () {
            if (idEl.value === last) return;
            last = idEl.value;

            setTimeout(apply, 90);
          };
          new MutationObserver(reapply).observe(idEl, {
            attributes: true,
            attributeFilter: ['value'],
          });
          setInterval(reapply, 400);
        }
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
